<ng-container></ng-container>
<h2 i18n="Welcome to Roughcheck">HEADING_WELCOME_TO_ROUGHCHECK</h2>
<button
  (click)="clickNext()"
  class="btn btn-primary"
  i18n="Start">BUTTON_START</button>
<p i18n="Welcome description">PARA_WELCOME_1</p>
<p i18n="Welcome description 2">PARA_WELCOME_2</p>
<p i18n="Welcome description 3">PARA_WELCOME_3</p>
<p i18n="Welcome description 4">PARA_WELCOME_4</p>
<p i18n="Welcome description 5">PARA_WELCOME_5</p>
<p i18n="Welcome description 6">PARA_WELCOME_6</p>
<p i18n="Roughcheck slogan: Roughcheck - the checklist with added intelligence">PARA_WELCOME_ROUGHCHECK_SLOGAN</p>
<p i18n="Welcome - Call to action"></p>
<p i18n="PARA_WELCOME_CALL_TO_ACTION"></p>
<button
  (click)="clickNext()"
  class="btn btn-primary"
  i18n="Start">BUTTON_START</button>
